<template>
  <div class="tag-anchor" :style="styles" :id="$attrs._id">
    <div class="tag-anchor__pos" :class="[`tag-anchor__pos--tail-${tailPosition}`, { 'tag-anchor__pos--highlight' : $attrs.isHighlighted }]">
      <div 
        class="tag-feature-text"
        :class="[ `tag-feature-text--tail-${tailPosition}`, {'tag-feature-text--highlight' : $attrs.isHighlighted }]"
        ref="el"
        v-html="label[lang]"
      >
      </div>
    </div>
  </div>

</template>
<script>
export default {
  props: ['pos', 'label', 'type', 'tail-position', 'lang'],

  computed: {
    styles () {
      return {
        left: `${(this.pos.x / 20)}em`,
        top: `${(this.pos.y / 20)}em`,
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/styles/_variables.scss";
@import "@/styles/_mixins.scss";

.tag-anchor {
  font-size: 1em;
  position: absolute;
  pointer-events: none;
  z-index: 5;

  &__pos {
    height: 0;
    width: 0;

    &--tail-top-left:after,
    &--tail-top-center:after,
    &--tail-top-right:after {
      @include tail3($basecolor)
    }

    &--tail-bottom-left:after,
    &--tail-bottom-center:after,
    &--tail-bottom-right:after {
      @include tail3($basecolor)
    }

    &--tail-left-center:after {
      @include tail3($basecolor)
    }

    &--tail-right-center:after {
      @include tail3($basecolor)
    }

    &--tail-no-tail:after {
      @include tail3($basecolor)
    }

    &--highlight {
      &::after,
      &::before {
        background-color: $basic-tag-highlight-color;
      }
    }
  }
}

.tag-feature-text {
  color: $feature-text-font-color;
  font-family: $touchscreen-font;
  font-size: $feature-text-font-size;
  font-style: italic;
  font-weight: 400;
  line-height: 1.1;
  width: max-content;
  padding: 0;
  pointer-events: auto;
  position: absolute;
  text-align: center;
  text-shadow: $feature-text-shadow;
  user-select: none;


  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  

  &--highlight {
    font-size: .75em;
    line-height: 1;
  }

  &--tail-top-left {
    left: 1em / $feature-text-font-size + em;
    text-align: left;
    top: initial;
    transform: translateY(-0.25em);
  }

  &--tail-top-center {
    left: 50%;
    top: 1em / $feature-text-font-size + em;
    transform: translateX(-50%);
  }

  &--tail-top-right {
    left: initial;
    right: 1em / $feature-text-font-size + em;
    text-align: right;
    top: initial;
    transform: translateY(-0.25em);
  }

  &--tail-bottom-left {
    bottom: .75em / $feature-text-font-size + em;
    left: -$feature-text-font-size;
    top: initial;
    text-align: left;
    transform: initial;
  }

  &--tail-bottom-center {
    bottom: .75em / $feature-text-font-size + em;
    left: 50%;
    top: initial;
    transform: translateX(-50%);
  }

  &--tail-bottom-right {
    bottom: .75em / $feature-text-font-size + em;
    left: initial;
    right: -$feature-text-font-size;
    text-align: right;
    top: initial;
    transform: initial;
  }

  &--tail-left-center {
    left: 1em / $feature-text-font-size + em;
    text-align: left;
    top: initial;
    transform: translateY(-50%);
  }

  &--tail-right-center {
    left: initial;
    right: 1em / $feature-text-font-size + em;
    text-align: right;
    top: initial;
    transform: translateY(-50%);
  }
}
</style>
